import { PrimitiveAtom } from 'jotai';
import { focusAtom } from 'jotai-optics';
import { Room } from '@/types';
import { surveyAtom } from './surveyAtom';

export const roomsAtom = focusAtom(surveyAtom, (optic) =>
  optic.optional().prop('rooms')
) as PrimitiveAtom<Array<Room>>;
